import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    breadCrumbContainer: {
      paddingBottom: "20px",
    },
    pageTitle: {
      width: "85%",
      marginBottom: "32px",
      [theme.breakpoints.down("1060")]: {
        width: "100%",
      },
    },
    modalIcon: {
      display: "flex",
      alignItems: "center",
      borderRadius: "50%",
      maxWidth: "48px",
      width: "100%",
      height: "48px",
      background: "#DCFAE6",
      justifyContent: "center",
      marginRight: "16px",
    },
    checkBoxAction: {
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
    },
    modalCheckBox: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginRight: "auto",
    },
    headingContainer: {
      [theme.breakpoints.down("1515")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        marginBottom: "64px",
      },
    },
    tableContainer: {
      marginTop: "32px",
      display: "flex",
      flexDirection: "column",
    },
    filtersButtons: {
      alignSelf: "flex-end",
      display: "flex",
      gap: "12px",
    },
    filtersContainer: {
      display: "flex",
      gap: "12px",
      width: "100%",
      marginTop: "16px",
      [theme.breakpoints.down("1092")]: {
        flexWrap: "wrap",
      },
    },
    inputwrapper: {
      width: "100% !important",
      maxWidth: "392px",
      [theme.breakpoints.down("500")]: {
        "& label": {
          minWidth: "auto",
        },
      },
      [theme.breakpoints.down("695")]: {
        maxWidth: "initial",
      },
    },
    autoCompleteInput: {
      width: "30%",
      minWidth: "190px",
      [theme.breakpoints.down("695")]: {
        width: "100%",
        minWidth: "initial",
      },
    },
    searchInput: {
      maxWidth: "392px",
      width: "100% !important",
      [theme.breakpoints.down("695")]: {
        maxWidth: "initial",
      },
    },
    buttonSortWrapper: {
      width: "165px",
    },
  };
});
